import { render, staticRenderFns } from "./CambioPw.vue?vue&type=template&id=c1a37998&scoped=true&"
import script from "./CambioPw.vue?vue&type=script&lang=js&"
export * from "./CambioPw.vue?vue&type=script&lang=js&"
import style0 from "./CambioPw.vue?vue&type=style&index=0&id=c1a37998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a37998",
  null
  
)

export default component.exports